<div class="flex flex-col">
    <div class="h-12 w-12 p-3 flex items-center justify-center bg-[#FFCE00] rounded-full mb-4">
        <img src="assets/images/warn-icon.svg" alt="warn-icon">
    </div>
    <h2 class="text-[#202020] text-[1.5625rem] font-semibold leading-8">
        Không tìm thấy {{ data.type === 'mic' ? "micrô" : "camera" }}
    </h2>

    @if(data.into === 'call') {
        <p class="mt-2 mb-6 flex-1 w-full overflow-y-auto text-black/60 text-sm font-normal leading-5 tracking-[-0.2px]">
            Bạn không thể {{ messageCustom }} vì có vẻ như máy tính của bạn không có {{ data.type === 'mic' ? "micrô" : "micrô hoặc camera" }}. Hãy thử kết nối {{ data.type === 'mic' ? "micrô" : "micrô và camera" }} hoặc nếu đã kết nối thì hãy thử khởi động lại trình duyệt.
        </p>
    } @else {
        <p class="mt-2 mb-6 flex-1 w-full overflow-y-auto text-black/60 text-sm font-normal leading-5 tracking-[-0.2px]">
            Bạn không thể {{ messageCustom }} vì có vẻ như máy tính của bạn không có {{ data.type === 'mic' ? "micrô" : "camera" }}. Hãy thử kết nối {{ data.type === 'mic' ? "micrô" : "camera" }} hoặc nếu đã kết nối thì hãy thử khởi động lại trình duyệt.
        </p>
    }

    <button nz-button nzType="primary" (keydown.enter)="onSubmit()" (click)="onSubmit()"
        class="w-full rounded-[10px] p-3 h-fit font-semibold text-base text-white bg-[#202020] border-[#202020] focus:bg-[#202020] focus:border-[#202020] hover:bg-[#202020]/80 hover:border-[#202020]/80 disabled:bg-[#787B82] disabled:text-white disabled:hover:bg-[#787B82] disabled:hover:text-white">
        Đã hiểu
    </button>
</div>